import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4v16","key":"svg-0"}],["path",{"d":"M4 6h12","key":"svg-1"}],["path",{"d":"M10 12h6","key":"svg-2"}],["path",{"d":"M6 18h10","key":"svg-3"}]]

/**
 * IconAlignRight2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tcmlnaHQtMiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAgNHYxNiIgLz4KICA8cGF0aCBkPSJNNCA2aDEyIiAvPgogIDxwYXRoIGQ9Ik0xMCAxMmg2IiAvPgogIDxwYXRoIGQ9Ik02IDE4aDEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/align-right-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignRight2 = createReactComponent('outline', 'align-right-2', 'AlignRight2', __iconNode);

export default IconAlignRight2;